import React from 'react';
import { useIntl } from 'react-intl';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Models
import { slaveFromTrigger, trigger, triggerCanHaveEquipement } from 'models/device';
import { isMotherboard } from 'models/deviceSlave';
import { isUsableForOnDemand } from 'models/equipment';
import { triggerType } from 'models/scenario';
// Custom
import { deviceDataShape, scenarioTriggerDataShape } from 'constants/PropTypesShapes';
import TriggerItem from 'installations/assets/configuration/TriggerItem';

const ScenarioTriggerItem = ({
  device, scenarioTrigger, toggled, showToggle, onToggle,
}) => {
  const intl = useIntl();
  // Get trigger object
  const triggerObj = trigger(scenarioTrigger.trigger_id, device);
  // Get slave from trigger
  const deviceSlave = slaveFromTrigger(triggerObj.id, device);
  // If the trigger can have equipments, display slave name
  const deviceLabel = triggerCanHaveEquipement(triggerObj) ? intl.formatMessage({ id: 'title.deviceSlave' }, { isMotherboard: isMotherboard(deviceSlave), desc: deviceSlave.name }) : '';

  // Display on-demand info if possible
  const onDemandInfo = triggerObj.equipment && isUsableForOnDemand(triggerObj.equipment) && scenarioTrigger.type === 'input';

  const nestedItems = [{
    key: 'stType',
    icon: triggerType(scenarioTrigger).icon,
    label: '',
    value: <LocalizedMessage id={`scenarioTrigger.type.${scenarioTrigger.type}`} />,
  }];
  if (onDemandInfo) {
    nestedItems.push({
      key: 'stOnDemand',
      icon: scenarioTrigger.on_demand_enabled ? 'checkActive' : 'checkInactive',
      label: '',
      value: <LocalizedMessage id="field.onDemandEnabled" />,
    });
  }

  return (
    <div className="information-item-wrapper">
      <TriggerItem
        trigger={triggerObj}
        deviceLabel={deviceLabel}
        showToggle={showToggle}
        toggled={toggled}
        onToggle={onToggle}
        initiallyOpen
        nestedItems={nestedItems}
      />
    </div>
  );
};

ScenarioTriggerItem.propTypes = {
  device: deviceDataShape.isRequired,
  scenarioTrigger: scenarioTriggerDataShape.isRequired,
  showToggle: PropTypes.bool,
  toggled: PropTypes.bool,
  onToggle: PropTypes.func,
};

ScenarioTriggerItem.defaultProps = {
  showToggle: false,
  toggled: false,
  onToggle: null,
};

module.exports = ScenarioTriggerItem;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/scenarios/ScenarioTriggerItem.js